const publicPages = ['/redeem-invite', '/redeem-invite/', '/product/', '/shop'];
const isPublicPage = publicPages.some((page) =>
  window.location.pathname.includes(page)
);

export default isPublicPage;
